import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { style } from './PickerSmartphone.style';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { useStore } from 'src/contexts/StoreContext';
import { SecondaryButton } from '@photosi/rn-components/buttons/secondary-button/SecondaryButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { brand } from 'src/theme/colors';
import { useEffect, useState } from 'react';
import Clipboard from '@react-native-clipboard/clipboard';
import QRCode from 'react-native-qrcode-svg';
import Spinner from '@photosi/rn-components/spinner/Spinner';
import { EDITOR_BASE_URL } from 'src/app/settings';
import { ROUTE_PATHS } from 'src/routes/_shared/routes.constants';

export const PickerSmartphone = observer(() => {
  const {
    i18n,
    project: { createShareTokenMobile, shareTokenMobile },
  } = useStore();
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (!shareTokenMobile) {
      createShareTokenMobile().then(res => {
        generateUrl(res);
      });
    } else {
      generateUrl(shareTokenMobile);
    }
  }, []);

  const generateUrl = (token: string) => {
    const urlUploadMobile = `${EDITOR_BASE_URL}/${ROUTE_PATHS.UPLOAD_SMARTPHONE}?shareToken=${token}`;
    setUrl(urlUploadMobile);
  };
  const copyUrl = async () => {
    Clipboard.setString(url);
  };

  const InstructionsContent = () => {
    return (
      <View style={style.instructions}>
        <TextLato style={style.stepsTitle}>{i18n.t('modal-picker-smartphone:upload')}</TextLato>
        <View style={style.stepsWrapper}>
          {[1, 2, 3].map(step => {
            return (
              <View style={style.step} key={`picker-smartphone-step-${step}`}>
                <TextLato style={style.stepNumber}>{step}</TextLato>
                <View>
                  <TextLato style={style.stepTitle}>{i18n.t(`modal-picker-smartphone:step-${step}-title`)}</TextLato>
                  <TextLato style={style.stepDescription}>
                    {i18n.t(`modal-picker-smartphone:step-${step}-description`)}
                  </TextLato>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  const ConnectedContent = () => {
    return (
      <View style={style.connected}>
        <View style={style.connectedIcon}>
          <Icon name={ICON_NAMES.Smartphone2} color={brand.main.water} />
        </View>
        <View style={style.textWrapper}>
          <TextLato style={style.connectedTitle}>{i18n.t('modal-picker-smartphone:connected-title')}</TextLato>
          <TextLato style={style.connectedDescription} numberOfLines={2}>
            {i18n.t('modal-picker-smartphone:connected-description')}
          </TextLato>
        </View>
      </View>
    );
  };

  return (
    <View style={style.wrapper}>
      <View>
        <View style={style.topContent}>
          <View style={style.qrCodeWrapper}>{url.length ? <QRCode size={145} value={url} /> : <Spinner />}</View>
          {isConnected ? <ConnectedContent /> : <InstructionsContent />}
        </View>
        <View>
          <SecondaryButton
            onPress={copyUrl}
            focusId={`picker-smartphone-step-button-copy-url`}
            focusOrder={0}
            focusGroup={FocusGroups.LOOKUP_CHOICE}
            style={{ minHeight: 38, paddingHorizontal: 24 }}
            disabled={!url.length}
          >
            {() => (
              <View style={style.cta}>
                <View style={style.ctaIcon}>
                  <Icon name={ICON_NAMES.Copy} color={brand.main.water} />
                </View>
                <TextLato style={style.ctaText}>{i18n.t('modal-picker-smartphone:copy-cta')}</TextLato>
              </View>
            )}
          </SecondaryButton>
        </View>
      </View>
    </View>
  );
});

PickerSmartphone.displayName = 'PickerSmartphone';